import { VAvatar, VChip } from "vuetify/lib";
import { getStringColor } from "kinnect-helpers";

export default {
	name: "KChip",

	functional: true,

	props: {
		avatar: Boolean,
		close: Boolean,
		identifier: [ Number, String ],
		inputValue: Boolean,
		small: Boolean,
		text: String
	},

	render( h, { props, listeners } ) {
		const {
			avatar,
			identifier,
			text,
			...propsToPass
		} = props;

		return <VChip
			attrs={propsToPass}
			key={props.identifier ? `${props.identifier}-chip` : `${props.text}-chip`}
			on={listeners}
		>
			{props.avatar && <VAvatar
				class="white--text"
				color={getStringColor( props.text )}
				left
			>{props.text ? props.text.slice( 0, 1 ).toUpperCase() : null}</VAvatar>}

			{props.text}
		</VChip>;
	}
};
